<template>
  <div class="row">
    <div class="col-md-12">
      <div class="form-group">
        <label><strong>ID</strong></label>
        <p id="id_id_detalhe">{{ dado.id }}</p>
      </div>
    </div>
    <div class="col-md-12">
      <div class="form-group">
        <label><strong>Cliente</strong></label>
        <p id="id_cliente_detalhe">{{ dado.cliente }}</p>
      </div>
    </div>
    <div class="col-md-10">
      <div class="form-group">
        <label><strong>Imóvel</strong></label>
        <p id="id_imovel_detalhe">{{ dado.imovel_exibicao }}</p>
      </div>
    </div>
    <div class="col-md-2">
      <div class="form-group">
        <label><strong>Data de Cadastro:</strong></label>
        <p id="id_data_cadastro_detalhe">{{ dado.data_cadastro }}</p>
      </div>
    </div>
    <div class="col-md-10">
      <div class="form-group">
        <label><strong>Descrição</strong></label>
        <p id="id_descricao_detalhe">{{ dado.descricao }}</p>
      </div>
    </div>
    <div class="col-md-2">
      <div class="form-group">
        <label><strong>Tipo de Danos:</strong></label>
        <p id="id_tipo_dano_detalhe" class="text-center">{{ dado.tipo_dano }}</p>
      </div>
    </div>
    <div class="col-md-4">
      <div class="form-group">
        <label><strong>Item</strong></label>
        <p id="id_item_detalhe">{{ dado.item }}</p>
      </div>
    </div>
    <div class="col-md-8">
      <div class="form-group">
        <label><strong>Elemento</strong></label>
        <p id="id_elemento_detalhe">{{ dado.elemento }}</p>
      </div>
    </div>
    <div class="col-md-8">
      <div class="form-group">
        <label><strong>Patologia</strong></label>
        <p id="id_patologia_detalhe">{{ dado.patologia }}</p>
      </div>
    </div>
    <div class="col-md-1">
      <div class="form-group">
        <label><strong>Prazo</strong></label>
        <p id="id_prazo_detalhe">{{ dado.prazo }}</p>
      </div>
    </div>
<!--    <div class="col-md-3" id="div_garantia_status">-->
<!--      <div class="form-group">-->
<!--        <label><strong>Status Garantia</strong></label>-->
<!--        <p id="id_status_garantia_detalhe">{{ dado.garantia.status }}</p>-->
<!--      </div>-->
<!--    </div>-->
    <div class="col-md-2">
      <div class="form-group">
        <label><strong>Status</strong></label>
        <p id="id_status_detalhe" v-html="dado.status"></p>
      </div>
    </div>
  </div>
  <div class="ibox-footer">
    <button class="btn btn-success font-bold" @click="$emit('fechar')">
      Fechar
    </button>
  </div>

</template>

<script>
import BaseModal from '@/components/base/BaseModal.vue';
import {apiRequest} from "../../../public/js/utils/funcoes";
import {apiUrl} from "@/router/apiBackRoutes";


export default {
  name: "InformacoesCrm",
  components: {
    BaseModal,
  },
  props: {
    itemKey: String,
  },
  data() {
    return {
      dado: 1,
      erro: null,
    };
  },
  emits: ['fechar'],
  methods: {
    async getDados() {
      const resultado = await apiRequest("GET", apiUrl.crm.retrieve(this.itemKey));
      if (resultado.success) {
        this.dado = resultado.data;
      } else {
        this.$toastMessage("warn", "Atenção", "Erro ao carregar registro!");
        console.error("Erro ao carregar:", resultado.error);
      }
    },
  },
  mounted() {
    this.getDados();
  },
}
</script>
